import { BaseWidget } from '@website-builder/widgets/base/base-widget';

export class BaseWidgetNormalizer {
  static normalizeInPlace<T extends BaseWidget>(widget: T, pureWidget?: T): T {
    widget.id = widget.id ?? pureWidget?.id;
    widget.name = widget.name ?? pureWidget?.name;

    return widget;
  }
}
